/**
 * @file Contains all query key prefixes that are used for the queries.
 */

export const aboutQueryKeyPrefix = 'ABOUT'
export const businessesQueryKeyPrefix = 'BUSINESSES'
export const businessesLocationsQueryKeyPrefix = 'BUSINESSES_LOCATIONS'
export const configurationUserQueryKeyPrefix = 'CONFIGURATION_USER'
export const configurationGlobalQueryKeyPrefix = 'CONFIGURATION_GLOBAL'
export const notificationQueryKeyPrefix = 'NOTIFICATIONS'
export const projectsQueryKeyPrefix = 'PROJECTS'
export const trackingsQueryKeyPrefix = 'TRACKINGS'
export const trackingKindsQueryKeyPrefix = 'TRACKING_KINDS'
export const usersQueryKeyPrefix = 'USERS'
export const userRolesQueryKeyPrefix = 'USER_ROLES'
export const workingTimeModelsQueryKeyPrefix = 'WORKING_TIME_MODELS'

export const listQueryKeyPrefix = 'LIST'
export const listAllQueryKeyPrefix = 'LIST_ALL'
export const detailsQueryKeyPrefix = 'DETAILS'
